import { apiGet } from 'lib/apiClient'

/**
 * listAudit: фильтры
 * - q: поиск по entity/action или по user_id (частично)
 * - dateFrom, dateTo: ISO строки
 * - limit/offset
 */
export async function listAudit({ q = '', dateFrom = '', dateTo = '', limit = 50, offset = 0 } = {}) {
  const params = { limit, offset };
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  if (q) params.q = q;

  const { data, error } = await apiGet('/audit/', params);
  if (error) throw new Error(error);

  return { rows: data.rows || [], count: data.count || 0 };
}
